import { ScaffoldSelection } from "../../interface";
import { isCellInSelection } from "./isCellInSelection";
import { isColInSelection } from "./isColInSelection";
import { isRowInSelection } from "./isRowInSelection";

/**
 * Returns whether a cell should be visually highlighted because it, its row, or its column is selected.
 *
 * @param selection - The current scaffold selection state.
 * @param rowId - The row ID of the cell.
 * @param colId - The column ID of the cell.
 * @returns True if the cell should appear highlighted.
 */
export const isCellHighlighted = (
  selection: ScaffoldSelection,
  rowId: string,
  colId: string,
): boolean =>
  isCellInSelection(selection, rowId, colId) ||
  isRowInSelection(selection, rowId) ||
  isColInSelection(selection, colId);
